import React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SearchIconSVG = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22",
  height: "22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.782.5c4.014 0 7.283 3.267 7.283 7.28 0 1.713-.62 3.274-1.619 4.519l8.054 8.05-1.138 1.151-8.06-8.057c-1.245.998-2.807 1.617-4.52 1.617C3.768 15.06.5 11.793.5 7.78S3.768.5 7.782.5zm0 1.618A5.654 5.654 0 002.118 7.78a5.654 5.654 0 005.664 5.663 5.654 5.654 0 005.664-5.663 5.654 5.654 0 00-5.664-5.662z",
  fill: "#6B6B6B"
})));

export { SearchIconSVG as default };
//# sourceMappingURL=bundle.esm5.js.map
